import http from '@/libs/AxiosPlugin'

const collectorPlan = {
  list () {
    return http.get('/collectorPlan/list')
  },

  production (id) {
    return http.post('/collectorPlan/production', {id})
  },

  productionStop (id) {
    return http.post('/collectorPlan/productionStop', {id})
  }
}

export default collectorPlan



// WEBPACK FOOTER //
// ./src/api/collectorPlan.js